// extracted by css-extract-rspack-plugin
export default {"billingTermsCard":"BwCqNkmBCRklRWhP","addTerm":"TCof7lm1Z0NR1coi","dateInput":"lic8DNOn6iMISqXa","quantityInput":"Xg5y3jQbJ8s1LYSG"};